import { PartyInvolved } from '../../../../../api/PartiesInvolved';
import { ReportStatus, ROReport } from '../../../../../api/Reports';
import { ReportTabListItem } from '../../../../../components/ui/tabs/PrimaryReportTabList';
import { ReportStatusPillVariant } from '../../../../../constants/reports'


export const createROTabItems = (
  parties: PartyInvolved[],
  reasonedOrders: Record<string, ROReport>,
  isDataLoading: boolean,
): ReportTabListItem[] => {
  return parties.map((party) => {
    const ro = reasonedOrders[party.party_id];

    let pillVariant: ReportStatusPillVariant;
    let pillText: string;

    if (isDataLoading) {
      pillVariant = 'default';
      pillText = 'Loading...';
    } else if (!ro) {
      pillVariant = 'generate';
      pillText = 'Generate';
    } else {
      switch (ro.status) {
        case ReportStatus.SUBMITTED:
        case ReportStatus.IN_PROGRESS:
          pillVariant = 'generate';
          pillText = 'Generating...';
          break;

        case ReportStatus.AVAILABLE:
          pillVariant = 'available';
          pillText = 'Available';
          break;
        
        default:
          pillVariant = 'generate';
          pillText = 'Generate';
      }
    }

    return {
      id: party.party_id,
      tabText: party.name,
      pillVariant,
      pillText,
      showBadge: true,
    };
  });
};


export const downloadFormats = [
    { value: 'pdf', label: 'PDF (.pdf)' },
    { value: 'docx', label: 'Word (.docx)' }
];